module.exports = __webpack_public_path__ + "img/HT01082-74.47a1dec5.jpg";